import React from "react";
import classNames from "classnames";
import { Image } from "semantic-ui-react";
import { LinePanel } from "components/containers";
import StarIcon from "assets/icons/star.svg";

const ContactTile = ({
  contact,
  onClick,
  highlight,
  tint,
  highlightFull,
  backgroundUrl,
  canDelete,
  renderDeleteContact,
}) => (
  <LinePanel
    onClick={onClick}
    className={classNames("contact-tile", onClick ? "pointer" : null)}
    highlight={highlight}
    highlightFull={highlightFull}
    tint={tint}
    backgroundUrl={backgroundUrl}
  >
    {canDelete ? renderDeleteContact(contact) : null}
    <header>{contact.displayName}</header>
    <span>
      {contact.isMain ? <Image src={StarIcon} className="primary" /> : null}
      <p>{contact.jobTitle || ""}</p>
    </span>
  </LinePanel>
);

export default ContactTile;
